import React from 'react';
import './Header.css';
import { Link } from 'react-router-dom';

import paiIcon from '../../landing/pai.svg';

export default function Header() {
  return (
    <header className="navbar">
      <div className="navbar__left">
        <img src={paiIcon} alt="PAI Logo" className="navbar__icon" />
        <span>PAI</span>
      </div>
      <nav className="navbar__links">
        <a
          href="#benefits"
          onClick={(e) => {
            e.preventDefault();
            const benefitsSection = document.getElementById("benefits");
            if (benefitsSection) {
              benefitsSection.scrollIntoView({ behavior: "smooth" });
            }
          }}
        >
          Преимущества
        </a>
        <a href="#why-us"  
          onClick={(e) => {
            e.preventDefault();
            const benefitsSection = document.getElementById("why-us");
            if (benefitsSection) {
              benefitsSection.scrollIntoView({ behavior: "smooth" });
            }
          }}> Почему мы</a>
        <a href="#assistant"
         onClick={(e) => {
          e.preventDefault();
          const benefitsSection = document.getElementById("assistant");
          if (benefitsSection) {
            benefitsSection.scrollIntoView({ behavior: "smooth" });
          }
        }}> ИИ ассистент</a>
      </nav>
      <Link to="/courses">
      <button className="navbar__button">Начать</button>
      </Link>
    </header>
  );
}
